import { render } from "./Shop.vue?vue&type=template&id=a90c012e&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=a90c012e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90c012e"]])

export default __exports__